import {Component, OnInit} from '@angular/core';
import {OAClient} from '../../../../models/oaclient';
import Commons from "../../commons";
import {AuthRESTService} from '../../../services/rest/auth-rest.service';
import {GetConfigService} from '../../../services/get-config.service';
import _ from 'lodash';
import {ActivatedRoute} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { MetaPropertySchema } from '../../../../models/metaPropertySchema';
import {environment} from '../../../../../environments/environment';
import { AppWidgetModule } from 'app/components/widgets/widget.module';
import { SharedModule } from 'app/shared.module';

declare var COMPONENTS: any;

@Component({
  standalone: true,
  imports: [SharedModule, AppWidgetModule],
	templateUrl: './form-field-edit.component.html',
	styleUrls: ['./form-field-edit.component.css']
})
export class FormFieldEditComponent extends Commons implements OnInit {
	formFieldMetaPropeties: MetaPropertySchema;
	propertyName: string;
	propertyId;
	errorMessage;
	systemConfig: any;
	getConfigService: GetConfigService;
	fieldTypes: any [] = ['text', 'email', 'file', 'checkbox']; // component types shall be added here
	invalidating_properties_options: any[] = [];

    constructor(private route: ActivatedRoute, private rest: AuthRESTService, toastr: ToastrService, translate: TranslateService, getConfigService: GetConfigService) {
		super(toastr, translate);
		this.formFieldMetaPropeties = new MetaPropertySchema();
		this.fieldTypes = this.fieldTypes.map((name) => {
			return { value: name, name: name };
		});
		this.getConfigService = getConfigService;
		this.onConfigChange = this.onConfigChange.bind(this);
		this.systemConfig = this.getConfigService.config;
		this.getConfigService.subscribeForConfigChange(this.onConfigChange);
		this.onConfigChange();
	}

	onConfigChange() {
		if (COMPONENTS && this.systemConfig) {
			COMPONENTS.filter((c) => {
				if (!c.meta.systemCodes || !c.meta.systemCodes.length) return true; //no codes means aplicable to all systems
				return c.meta.systemCodes.includes(this.systemConfig.code);
			}).forEach((c) => {
				this.fieldTypes.push({ value: c.meta.name, name: c.meta.name});
			});
		}
	}

    ngOnInit() {
        this.route.params.subscribe(params => {
			let id = params['id'];
            this.rest.get('property').subscribe((props) => {
				props.some((prop) => {
					if (prop.id == id) {
						this.propertyName = prop.name || 'not named';
						this.propertyId = prop.id;
						let display = prop.display && JSON.parse(prop.display);
						Object.assign(this.formFieldMetaPropeties, prop, {
							display: display || this.formFieldMetaPropeties.display });
						this.invalidating_properties_options = props.filter((p) => p.id !== prop.id && p.name !== 'password').map((p) => {
							let display = JSON.parse(p.display);
							return {
								value: p.id,
								name: display && display.placeholder && display.placeholder[localStorage.getItem('userLang')] || p.name,
								selected: this.formFieldMetaPropeties.invalidating_properties
									&& this.formFieldMetaPropeties.invalidating_properties.some((ip) => ip.id === p.id) || false
							};
						});
						return true;
					}
				})
            }, err => this.errorHandler(err))
        });
	}

	ngOnDestroy(): void {
		this.getConfigService.unsubscribe(this.onConfigChange);
	}

    save(): void {
		this.clearNotifications();
		this.rest.post('property', this.formFieldMetaPropeties.getNormalizedForSave()).subscribe((reseponse) => {
			this.addSuccess('general.saved');
        }, err => this.errorHandler(err))
    }

}
